<template>
<div class="templateDoctor">
            <h4 class=" text-center text-secondary pt-5"> Covid / နာတာရှည်/ သက်ကြီးရွယ်အို လူနာများအတွက် အိမ်အရောက်ဝန်ဆောင်မှုအကူအညီ </h4>
             <div class="row m-5">
                        <div class=" col-md-5 mx-auto d-block card m-3 p-4 card-glass " v-for="doctor in doctors" :key="doctor.id">
                                <div class="card-body">
                                    <h5 class="card-title text-danger"> {{ doctor.name }}</h5>
                                    <div class="row mt-3">
                                        <div class="col-md-6 ">
                                                <div class="row">
                                                            <div class="col">
                                                                    <span class="link-dark">ဖုန်း - </span>
                                                            </div>
                                                            <div class="col">
                                                                        <div class="mb-1">
                                                                            <a :href="'tel:'+doctor.ph" class=" text-decoration-none">  {{doctor.ph}}</a> 
                                                                        </div>

                                                                        <div class="mb-1">
                                                                            <a :href="'tel:'+doctor.ph1" class=" text-decoration-none">  {{doctor.ph1}}</a> 
                                                                        </div>

                                                                        <div>
                                                                            <a :href="'tel:'+doctor.ph2" class=" text-decoration-none">   {{doctor.ph2}}</a> 
                                                                        </div>

                                                                            <div class="mb-1">
                                                                            <a :href="'tel:'+doctor.ph3" class=" text-decoration-none">  {{doctor.ph3}}</a> 
                                                                        </div>

                                                                        <div>
                                                                            <a :href="'tel:'+doctor.ph4" class=" text-decoration-none">  {{doctor.ph4}}</a> 
                                                                        </div>

                                                                        <div>
                                                                            <a :href="'tel:'+doctor.ph5"  class=" text-decoration-none"> {{doctor.ph5}}</a> 
                                                                        </div>
                                                                           <div>
                                                                            <a :href="'tel:'+doctor.ph6" class=" text-decoration-none">  {{doctor.ph7}}</a> 
                                                                        </div>

                                                                        <div>
                                                                            <a :href="'tel:'+doctor.ph7"  class=" text-decoration-none"> {{doctor.ph7}}</a> 
                                                                        </div>
                                                            </div>

                                                    </div>
                                                  
                                            </div>
                                              <small class="text-muted mt-2"> ဖုန်းနံပါတ်ကိုနှိပ်ပြီးခေါ်ဆိုနိုင်ပါသည် </small>

                                               <div class="col-md-6 mt-3 ">
                                                    <small class=""> {{ doctor.note}} </small>
                                            </div>
                                    </div>
                                  
                                   
                                 
                                    
                                </div>
                        </div>      

            </div>        
           
        </div>
</template>

<script>
export default {
    name: "Doctor",

    data(){
        return {
    doctors : [
        {name:'Doctors On Wheels', ph:'+959442333535' , ph1:'+959961211300'},
        {name:'Housecall Doctors Network' , ph:'+959443597933', ph1:'+959958130820', ph2:'+959953000192'},
        {name:'Doctors House Call (အိမ်ပင့်ဆရာဝန်)', ph:'+959757936477' },
        {name:'ဒေါက်တာသွေး', ph:'+959426601150', ph1:'+959765159044'},
        {name:'Dr Htein Laboratory and Medical Check up Services', ph:'+959400868001', ph1:'+959400868002',ph2:'+959400868003', ph3:'+959400868004',ph4:'+959400868005', ph5:'+959400868006',ph6:'+959400868007', ph7:'+959400868008'},
        {name:'Hantha Pharmacy' , ph:'+959448053310', note:'oxygen level နည်းသောလူနာများကို အဓိကထားကြည့်သောကြောင့် oxygen 93 အထက်နှင့် ရိုးရိုးဖျားနာလူနာမျာကို မကြည့်ပေးပါ '},
        {name:'DR.House', ph:'+959421012314', note:'ည ၈ နာရီ booking များ ဖုန်းလက်ခံဖြေပေးသည်'},

        {name:'Ayeyarwaddy Traning Center ATC' , ph:'+959448428883'},
        {name:'Ei Thu.nurse services', ph:'+959677699639', ph1:'+959899032581'},
         {name:'စွမ်းထက်သူနာပြု နှင့် သူနာပြုအကူဝန်ဆောင်မှု', ph:'+959445799156', ph1:'+959445799159'},
         {name:'နိုက်တင်ဂေး ဆေးရုံနှင့်အိမ်အရောက်သူနာပြုဝန်ဆောင်မှု' , ph:'+959459286015'},
         {name:'SKT Nurse Services', ph:'+959960956460'},
          
    ]
    }

    }

  
}

</script>

<style>
    .templateDoctor {
       
          background:linear-gradient(to right top, #f7e9be, #e2e8e9);
      
          align-items: center;
          justify-content: center;
          
        }
</style>